// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_3OjJzi5yyxfc4_fR3vRYra","image":"_2Ueo9LOLnk4H_4KZpEA-r6","letter":"_26GdBUCsfb2MuzwKhPauwk"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/avatar/theme.css
// module id = 1027
// module chunks = 0